import { Location } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { OrderService } from './service/order.service';
import { DataComponent } from './data/data.component';
import { ProductsComponent } from './products/products.component';
import { BudgetComponent } from './budget/budget.component';
import { LoadingService } from 'src/app/services/shared/loading.service';
import { ApcSectionAnchorsComponent } from 'src/app/ui/apc-section-anchors/apc-section-anchors.component';
@Component({
  selector: 'nejo-order-page',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent {
  @ViewChild(DataComponent) dataComponent: DataComponent;
  @ViewChild(ProductsComponent) productsComponent: ProductsComponent;
  @ViewChild(BudgetComponent) budgetComponent: BudgetComponent;
  @ViewChild(ApcSectionAnchorsComponent) sectionAnchors: ApcSectionAnchorsComponent;
  public firstLoad = true;

  constructor(
    public location: Location, 
    public orderService: OrderService, 
    private router: Router,  
    private loadingService: LoadingService
  ) {
    this.firstLoad = true;
  }

  public buttons = [
    {
      key: 'budgets',
      svg: 'assets/ico/budget.svg',
      permission: {
        role: 'editor',
      },
      tooltipMessageKey: 'order.budget.newBudget',
    },
    {
      key: 'products',
      svg: 'assets/ico/user-solid.svg',
      permission: {
        role: 'editor',
      },
      tooltipMessageKey: 'order.product.newProduct',
    }
  ];

  public sections = [
    {
      label: 'order.orderData',
      icon: 'assets/ico/orders.svg',
      anchor: 'nejo-order-data',
      permission: {
        role: 'viewer',
      },
    },
    {
      label: 'order.product.title',
      icon: 'assets/ico/user-solid.svg',
      anchor: 'product',
      permission: {
        role: 'viewer',
      },
    },
    {
      label: 'order.budget.title',
      icon: 'assets/ico/budget.svg',
      anchor: 'budget',
      permission: {
        role: 'viewer',
      },
    },
  ];

  createElement(key: string) {
    if (key == 'products') {
      this.productsComponent.addNewSection();
    }
    else if (key == 'budgets') {
      this.budgetComponent.addNewSection();
    }
  }

  ngAfterViewChecked(): void {
    var subDetailId = this.router.url.split('/')[4];
    if (this.firstLoad && this.loadingService.loadingRequests.length === 0) {
      this.firstLoad = false;
      switch (this.router.url.split('/')[3]) {
        case 'project':
          this.sectionAnchors.scrollTo(subDetailId ? subDetailId : 'project');
          break;
        case 'budget':
          setTimeout(() => this.sectionAnchors.scrollTo(subDetailId ? subDetailId : 'budget'), 500);
          break;
      }
    }
  }
}
